import request from '../request'

/**
 * 设计输入要求记录相关接口
 * 从 cosystem-portal 同步过来的入口，本仓暂未启用对应后端，使用前请核对 URL。
 */

export function addDesignInputReq(data) {
    return request({
        url: '/project-service/cosys/design/input/req/add',
        method: 'POST',
        data
    })
}

export function fetchDesignInputReqDetail(id) {
    return request({
        url: `/project-service/cosys/design/input/req/detail/${id}`,
        method: 'GET'
    })
}

export function fetchDesignInputReqList(params) {
    return request({
        url: '/project-service/cosys/design/input/req/list',
        method: 'GET',
        params
    })
}

export function resubmitDesignInputReq(data) {
    return request({
        url: '/project-service/cosys/design/input/req/resubmit',
        method: 'POST',
        data
    })
}

export function updateDesignInputReq(data) {
    return request({
        url: '/project-service/cosys/design/input/req/update',
        method: 'POST',
        data
    })
}

export function exportInputReq(id) {
    return request({
        url: `/project-service/cosys/design/input/req/export/${id}`,
        method: 'GET',
        responseType: 'json',
    })
}
